import React, { useCallback, useEffect, useState } from "react";
import { MessageCircle, RefreshCw } from "lucide-react";
import { Panel, MonoLabel } from "@/components/Panel";
import { toast } from "sonner";
import { adminApi, apiErr } from "@/lib/authApi";

export function useCampaigns(pollMs = 5000) {
  const [data, setData] = useState(null);
  const load = useCallback(() => adminApi.get("/admin/whatsapp/campaigns").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, pollMs); return () => clearInterval(t); }, [load, pollMs]);
  return { data, reload: load };
}

export function BroadcastMonitor({ campaigns, reload }) {
  const [busy, setBusy] = useState("");
  const retrigger = async (c) => {
    setBusy(c.template_key);
    try {
      const { data } = await adminApi.post("/admin/whatsapp/retrigger", { template_key: c.template_key, status_in: ["failed"] });
      toast.success(`${c.name}: re-queued ${data.requeued} failed message${data.requeued === 1 ? "" : "s"}`);
      reload();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  const list = (campaigns || []).filter((c) => c.template_key !== "otp");
  return (
    <Panel className="p-6 lg:col-span-5" data-testid="broadcast-monitor">
      <div className="flex items-center justify-between">
        <MonoLabel>WhatsApp Broadcast Monitor</MonoLabel>
        <MessageCircle size={14} style={{ color: "var(--green)" }} />
      </div>
      <div className="mt-4 space-y-3">
        {!campaigns && <div className="mono-label" data-testid="broadcast-loading">Loading…</div>}
        {list.map((c) => (
          <div key={c.template_key} className="hairline p-3" data-testid={`campaign-${c.template_key}`}>
            <div className="flex justify-between items-center flex-wrap gap-2">
              <div className="text-sm">{c.name}{!c.active && <span className="chip ml-2">inactive</span>}</div>
              <button data-testid={`wa-retrigger-${c.template_key}`} disabled={!!busy || !c.failed} onClick={() => retrigger(c)}
                className="mono-label inline-flex items-center gap-1 hover:text-[var(--red)] disabled:opacity-40" style={{ color: "var(--red-2)" }}>
                <RefreshCw size={10} className={busy === c.template_key ? "animate-spin" : ""} /> Retrigger failed
              </button>
            </div>
            <div className="mt-2 grid grid-cols-5 gap-2 text-center">
              <WaStat k="QUEUE" v={c.queued} />
              <WaStat k="SENT" v={c.sent} />
              <WaStat k="DELIV" v={c.delivered} c="green" />
              <WaStat k="READ" v={c.read} c="green" />
              <WaStat k="FAIL" v={c.failed} c="red" />
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
}

function WaStat({ k, v, c }) {
  const color = c === "green" ? "var(--green)" : c === "red" ? "var(--red-2)" : "var(--text)";
  return (
    <div>
      <div className="mono-label" style={{ color: "var(--taupe)" }}>{k}</div>
      <div className="font-mono text-sm mt-1" style={{ color }}>{Number(v || 0).toLocaleString("en-IN")}</div>
    </div>
  );
}
